//api.js
// import agents from './agents'
import api from './common.js'

export default {

  // Получить курс валюты к дефолтной валюте (предполагается что дефолтная валюта - рубль)
  // payload:  { currency_id: Х }
  getCourse(payload, cb, cb_fail){
    if (payload === undefined) payload = {};
    api.request({
      url: '/api/v1/get_current_course',
      payload
    }, cb, cb_fail);
  },


  // Получаем список городов в JSON.
  // payload позволяет передать параметры для фильтра на бэкенде
  getCities(cb, payload) {
    if (payload === undefined) payload = {};
    // console.log('getCities... ', payload);

    api.request({
      url: '/cities',
      payload: payload,
    },cb);
  },


  // Получаем список городов в JSON.
  // payload позволяет передать параметры для фильтра на бэкенде
  getHotels(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/hotels',
      payload: payload,
    },cb);
  },


  // Получаем список стран в JSON.
  // payload позволяет передать параметры для фильтра на бэкенде
  getCountries(cb, payload) {
    if (payload === undefined) payload = {};

    // console.log('getCountries... ', payload);

    api.request({
      url: '/countries',
      payload: payload,
    }, cb);
  },


  // Получаем список валют в JSON.
  // payload позволяет передать параметры для фильтра на бэкенде
  getCurrencies(cb, payload) {
    if (payload === undefined) payload = {};

    // console.log('getCurrencies... ', payload);

    api.request({
      url: '/currencies',
      payload: payload,
    }, cb);
  },


  // Получаем список поставщиков в JSON.
  // payload позволяет передать параметры на бэкенд
  getProviders(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/providers',
      payload: payload,
    }, cb);
  },


  // Получаем список CountryLink в JSON.
  // payload позволяет передать параметры для фильтра на бэкенде
  getCountryLinks(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/country_links',
      payload: payload,
    }, cb);
  },


  // Получаем список CityLink в JSON.
  // payload позволяет передать параметры для фильтра на бэкенде
  getCityLinks(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/city_links',
      payload: payload,
    }, cb);
  },


  // Получаем список дат тура в JSON.
  // Предполагается, что в payload - {tour_id: X}; include_rooms: true — с номерами и группами отелей
  getTourDates(cb, payload, cb_fail) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/tour_dates',
      payload: payload,
    }, cb, cb_fail);
  },


  // Получаем список туров в JSON.
  getTours(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/tours',
      payload: payload,
    }, cb);
  },


  // Получаем список HotelGroups в JSON.
  // Предполагается, что в payload - {tour_date_id: X}
  getHotelGroups(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/hotel_groups',
      payload: payload,
    }, cb);
  },


  // Получаем список связей customer_order в JSON.
  // Предполагается, что в payload - {order_id: X}
  getCustomerOrders(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/customer_orders',
      payload: payload,
    }, cb);
  },


  // Получаем список связей customer_order в JSON.
  // Предполагается, что в payload - {order_id: X}
  getBookings(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/bookings',
      payload: payload,
    }, cb);
  },


  // Получаем список физ лиц customers в JSON.
  // payload - можно передать параметры поиска для ransack
  getCustomers(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/customers',
      payload: payload,
    }, cb);
  },


  // Получаем список юр. лиц entities в JSON.
  // payload - можно передать параметры поиска для ransack
  getEntities(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/entities',
      payload: payload,
    }, cb);
  },

  // Получаем список гидов guides в JSON.
  getGuides(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/guides/admin_index',
      payload: payload,
    }, cb);
  },


  getMessages(payload, cb, cb_fail) {
    if (payload === undefined) payload = {};
    api.request({
      url: `/chats/${payload.chat_id}/messages`,
    }, cb, cb_fail)
  },

  readAllMessages(payload, cb, cb_fail) {
    if (payload === undefined) payload = {};
    api.request({
      url: `/chats/${payload.chat_id}/read_all`,
      format: 'POST',
    }, cb, cb_fail)
  },

  // Create message
  // Payload is must contain message attributes
  // {body: '...', order_id: X, ...}
  createMessage(payload, cb, cb_fail) {
    api.request({
      url: '/messages',
      payload: {message: payload},
      format: 'POST'
    }, cb, cb_fail)
  },


  // Payload is must contain linked attributes
  // {linked_id: X, linked_type: '...'}
  getDocs(payload, cb, cb_fail) {
    if (payload === undefined) payload = {};
    api.request({
      url: `/docs/${payload.linked_type}/${payload.linked_id}`,
    }, cb, cb_fail)
  },

  // Create Doc
  // Payload is must contain doc attributes
  // data = new FormData();
  // data.append(`secure_document[file]`, document.getElementById(this.key).files[0] )
  // {file: '...', linked_id: X, linked_type: '...'}
  createDoc(payload, cb, cb_fail) {
    api.request({
      url: '/docs',
      payload: payload.data,
      format: 'POST',
      processData: false,
      contentType: false,
    }, cb, cb_fail)
  },

  destroyDoc(payload, cb, cb_fail) {
    api.request({
      url: `/docs/${payload.id}`,
      format: 'DELETE',
    }, cb, cb_fail)
  },



  getAlerts(payload, cb, cb_fail) {
    api.request({
      url: `/alerts`,
    }, cb, cb_fail)
  },

  destroyAlert(payload, cb, cb_fail) {
    api.request({
      url: `/alerts/${payload.id}`,
      format: 'DELETE',
    }, cb, cb_fail)
  },

  // Создаем новую дату тура и получаем её в JSON.
  // payload должен содержать параметры создаваемого объекта
  createTourDate(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/tour_dates',
      payload: {tour_date: payload},
      format: 'POST',
    },cb);
  },


  // Создаем новую дату тура и получаем её в JSON.
  // payload должен содержать параметры создаваемого объекта
  // order_id is required
  createBooking(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/bookings',
      payload: {booking: payload},
      format: 'POST',
    },cb);
  },


  // Создаем новую дату тура и получаем её в JSON.
  // payload должен содержать параметры создаваемого объекта
  updateBookingPlacementLinks(cb, payload, id) {
    if (payload === undefined) payload = {};
    if (id === undefined) {
      console.error('[API.updateBookingPlacementLinks] ERROR: id is undefined');
      return false;
    }
    api.request({
      url: `/bookings/${id}/update_placements`,
      payload: {links: payload},
      format: 'PATCH',
    },cb);
  },


  // Создаем связь клиент-заказ и получаем её в JSON.
  // payload должен содержать параметры создаваемого объекта
  createCustomerOrder(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/customer_orders',
      payload: {customer_order: payload},
      format: 'POST',
    },cb);
  },


  // Создаем копию даты тура и получаем её в JSON.
  // payload должен содержать id оригинального объекта.
  copyTourDate(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: `/tour_dates/${payload.id}/copy`,
      format: 'POST',
    },cb);
  },


  // Создаем новый номер в дате тура и получаем его в JSON.
  // payload должен содержать параметры создаваемого объекта
  // без корневого ключа
  createTourDateRoom(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/tour_date_rooms',
      payload: {tour_date_room: payload},
      format: 'POST',
    },cb);
  },


  // Создаем новую группу в дате тура и получаем её в JSON.
  // payload должен содержать параметры создаваемого объекта
  // без корневого ключа
  createHotelGroup(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/hotel_groups',
      payload: {hotel_group: payload},
      format: 'POST',
    },cb);
  },


  // Удаляем Связь со Страной (country_link) и получаем его в JSON.
  // payload должен содержать id - {id: 1}
  deleteCountryLink(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/country_links/' + payload.id,
      format: 'DELETE',
    },cb);
  },


  // Удаляем Группу отелей (hotel_group) и получаем её в JSON.
  // payload должен содержать id - {id: 1}
  deleteHotelGroup(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/hotel_groups/' + payload.id,
      format: 'DELETE',
    },cb);
  },


  // Удаляем Номер из группы (tour_date_room) и получаем её в JSON.
  // payload должен содержать id - {id: 1}
  deleteTourDateRoom(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/tour_date_rooms/' + payload.id,
      format: 'DELETE',
    },cb);
  },


  // Удаляем Связь с Городом (city_link) и получаем его в JSON.
  // payload должен содержать id - {id: 1}
  deleteCityLink(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/city_links/' + payload.id,
      format: 'DELETE',
    },cb);
  },


  // Удаляем Связь Клиента с Договором (customer_order) и получаем его в JSON.
  // payload должен содержать id - {id: 1}
  deleteCustomerOrder(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/customer_orders/' + payload.id,
      format: 'DELETE',
    },cb);
  },


  // Удаляем Дату Тура (tour_date) и получаем её в JSON.
  // payload должен содержать id - {id: 1}
  deleteTourDate(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/tour_dates/' + payload.id,
      format: 'DELETE',
    },cb);
  },


  // Удаляем Группу номеров (booking) и получаем её в JSON.
  // payload должен содержать id - {id: 1}
  deleteBooking(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/bookings/' + payload.id,
      format: 'DELETE',
    },cb);
  },


}
